export const SOURCE_NAME = 'module-communication';
